/* eslint-disable no-undef */
$(() => {
  const options = {
    valueNames: [
      { name: 'department', attr: 'data-info' },
      { name: 'category', attr: 'data-info' },
      { name: 'date', attr: 'data-info' },
      'title',
    ],
  };

  const newsList = new List('news', options);
  const $filterControls = $('#filters').find('select.filter-controls');
  const $searchInput = $('#news-list-search');

  const scrollToTop = function () {
    $('body,html').scrollTop(0);
  };

  $searchInput.on('focus', () => {
      $filterControls.val('');
    }).on('keyup', function () {
      const val = $(this).val();
      newsList.search(val, ['title']);
      scrollToTop();
  });


  $filterControls.on('change', function () {
    const $this = $(this);
    const which = $this.data('controls');
    const searchString = $this.find(':selected').val();
    const $siblings = $this.siblings('select');

    $filterControls.removeClass('active');
    $this.addClass('active');
    $siblings.val('');
    $searchInput.val('');
    newsList.search(searchString, [which]);
    scrollToTop();
    history.replaceState(null, null, `#${searchString}`);
  });

  $('.badge').on('click', function (e) {
    const $this = $(this);
    const which = $this.data('list');
    const searchString = $(this).data('info');
    newsList.search(searchString, [which]);
    scrollToTop();
    history.replaceState(null, null, `#${searchString}`);
  });
  if (window.location.hash) {
      const hash = window.location.hash.substring(1);
      newsList.search(hash);
  }
});
